import React, { useState, useEffect, useContext, useCallback } from "react";
import { injectIntl } from "react-intl";
import { FixtureDetailsContext } from "../../../Config/FixtureDetails";
import Button from "../../Base/Button/Button";
import { sendClockEvent } from "../../Base/Utilities/ClockEvents";
import ClockAdjust from "../Clock/ClockAdjust/ClockAdjust";

import "./WarmupClock.scss";

function WarmupClock(props) {
  const { intl, currentState, updateState } = props;
  const { period } = currentState;
  const { formatMessage } = intl;
  const [seconds, setSeconds] = useState(8);
  const [isActive, setIsActive] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);
  const { fixtureProfile } = useContext(FixtureDetailsContext);
  const { warmupSeconds } = fixtureProfile;

  useEffect(() => {
    if (warmupSeconds) {
      sendClockEvent("sport", "fixture", "warm_up", props);
      updateState("period", {
        periodId: currentState.period.periodId,
        periodStatus: "warm_up",
      });
      setSeconds(warmupSeconds);
      setIsActive(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warmupSeconds]);

  useEffect(() => {
    let interval;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    }

    if (seconds === 0) {
      setIsActive(false);
    } else {
      setIsActive(true);
    }

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, seconds]);

  const _handleKeyDown = useCallback((event) => {
    event.preventDefault();
    setCurrentKey(event.code);
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", _handleKeyDown);
    return () => window.removeEventListener("keydown", _handleKeyDown);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentKey !== null) {
      switch (currentKey) {
        case "ArrowUp":
          if (seconds < warmupSeconds) {
            setSeconds(seconds + 1);
          }
          break;
        case "ArrowDown":
          if (seconds > 0) {
            setSeconds(seconds - 1);
          }
          break;
        case "ArrowRight":
          if (seconds < warmupSeconds - 59) {
            setSeconds(seconds + 60);
          }
          break;
        case "ArrowLeft":
          if (seconds > 59) {
            setSeconds(seconds - 60);
          }
          break;
        default:
          break;
      }
    }
    setCurrentKey(null);
    // eslint-disable-next-line
  }, [currentKey]);

  const renderClock = () => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds - minutes * 60;

    return (
      <>
        {String(minutes).padStart(2, "0")}:{String(secs).padStart(2, "0")}
      </>
    );
  };

  useEffect(() => {
    const listener = () => {
      if (period.periodStatus === "warm_up") {
        onWarmupEnd();
      }
    };

    window.addEventListener("beforeunload", listener);
    return () => window.removeEventListener("beforeunload", listener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period]);

  const onWarmupEnd = () => {
    sendClockEvent("sport", "fixture", "pending", props);
    sendClockEvent("sport", "period", "pending", props);
    updateState("period", {
      periodId: currentState.period.periodId,
      periodStatus: "pending",
    });
    updateState("primary", null);
  };

  return (
    <div className="warmup-clock">
      <div className="warmup-clock-main">
        <ClockAdjust className="adjust-minutes" up="ArrowRight" down="ArrowLeft" />
        <p>{renderClock()}</p>
        <ClockAdjust className="adjust-seconds" up="ArrowUp" down="ArrowDown" />
      </div>
      <div className="warmup-clock-controls">
        <Button onClick={onWarmupEnd}>
          {formatMessage({
            id: "warmup.end",
            defaultMessage: "End warm up",
          })}
        </Button>
      </div>
    </div>
  );
}

export default injectIntl(WarmupClock);
